import { makeStyles } from '@material-ui/core';
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import OnOffByScroll from '../Animation/onOffByScroll';
import ContentTitle from '../General/contentTitle';
import Clock from '../General/clock';
import various from '../General/various';
import {
  memberDetailByUserEmail,
  getStripeCustomerInfo,
  setDoNotShowAgain,
  reportSeminarPresetDiagnostic,
} from '../Apis/apiOfManaged';
import { paramsIndexForGeneral } from '../Apis/apis';
import {
  checkSeminarStatus,
  choiceSeminarProduct,
  productMasterDetailOnlyPrice,
  seminarApply,
} from '../Apis/apis';
import { seminarDetailPreview } from '../Apis/apis';
import { AuthContext } from '../auth';
import {
  emailRegValidator,
  emailValidator,
} from '../CommonFunction/validators';
import Footer from '../Footer/footer';
import { ogpGenerator } from '../ogp';
import StandardDialog from '../Dialog/standardDialog';
import { Spinner } from '../Spinner';
import imageIndex from '../img/imageIndex';

const useStyles = makeStyles((theme) => ({
  contentTitle: {
    marginTop: '168px',
    '& > div': {
      '& > span': {
        '& > span': {
          '& > span': {
            lineHeight: '64px !important',
            textAlign: 'justify',
          },
        },
      },
    },
  },
  applyContents: {
    marginTop: '176px',
    display: 'flex',
    margin: 'auto 0',

    '& #read': {
      width: 'calc(70vw * 0.7)',
      marginBottom: '56px',
      textAlign: 'start',
      fontWeight: 'bold',
      lineHeight: '3.5rem',
      fontSize: '1rem',

      '& > div': {
        width: '100%',
        display: 'flex',
        justifyContent: 'start',
        flexWrap: 'nowrap',
        lineHeight: '40px',
        '& > div': {
          width: '28%',
          textAlignLast: 'end',
          // marginRight: '16px',
        },
        '& > span': {
          display: 'inline-block',
          width: '72%',
          textAlignLast: 'end',
        },
      },
      '& #title': {
        '& > div': {
          fontSize: 'clamp(8px, 1rem, 1rem)',
        },
        '& > span': {
          display: 'inline-block',
          width: '72%',
          margin: 0,
          fontSize: '1.5rem',
          fontWeight: 'bold',
          verticalAlign: 'middle',
        },
      },
      '& #place, & #price': {
        width: '72%',
        display: 'flex',
        flexFlow: 'column',
        textAlignLast: 'end',
        '& #note, & #cashOnly': {
          display: 'block',
          width: '100%',
          fontSize: '0.7rem',
          fontWeight: 'normal',
          opacity: '0.5',
          verticalAlign: 'bottom',
          textAlignLast: 'end',
          lineHeight: '1rem !important',
        },
      },
    },
    '@media screen and (max-width:1000px)': {
      flexFlow: 'column',
      '& $image': {
        width: '92vw',
        '& > img': {
          display: 'inline-block',
          width: '92vw',
          // height: 'calc(92vw / 1.5)',
          height: '92vw',
        },
      },
      '& #read': {
        width: '100%',
        marginTop: '32px',
        '& #place, & #price': {
          '& #note, & #cashOnly': {},
        },
      },
    },
    '@media screen and (max-width:550px)': {
      '& #read': {
        '& > div': {
          display: 'flex',
          flexWrap: 'wrap !important',
          justifyContent: 'start',
          lineHeight: '2rem',
          marginBottom: '32px',
          '& > div, & > span': {
            textAlignLast: 'start !important',
            marginLeft: '0px !important',
            width: '100% !important',
            lineHeight: '24px',
          },
          '& > div,': {
            fontStyle: 'italic',
          },
        },
        '& #place, & #price': {
          '& #note, & #cashOnly': {
            textAlignLast: 'start !important',
          },
        },
      },
    },
  },
  image: {
    width: 'calc(70vw * 0.3)',
    marginRight: '3vw',
    '& > img': {
      width: 'calc(70vw * 0.3)',
      height: 'calc(70vw * 0.3)',
      objectFit: 'cover',
      // filter:
      //   'contrast(100%) grayscale(100%) saturate(0%) drop-shadow(2px 2px 2px black)',
      filter: 'drop-shadow(2px 2px 2px black)',
    },
  },

  titles: {},
  inputs: {},
  helptext: {},
  onlyAll: {},
  error: {
    color: 'red',
    fontSize: '0.7em',
  },
  formContainer: {
    marginTop: '168px',
    width: '100%',
    fontSize: '0.9em',
    '& > form': {
      '& > p': {
        fontSize: '0.7em',
        textAlign: 'center',
      },
      '& > div': {
        width: '70%',
        display: 'flex',
        margin: '0 auto',
        marginBottom: '32px',

        '& > div': {
          textAlign: 'start',
          display: 'flex',
          justifyContent: 'start',
          '@media screen and (max-width:750px)': {
            width: '100%',
          },
        },

        '& $titles': {
          width: '30%',
          marginRight: '32px',
          '& > label': {
            width: '100%',
            textAlign: 'end',
            fontSize: '1rem',
          },
          '& > span': {
            color: 'red',
          },
          '@media screen and (max-width:750px)': {
            width: '100%',
            '& > label': {
              width: '160px',
              textAlign: 'start',
              marginBottom: '16px',
            },
          },
        },

        '& $inputs': {
          width: '70%',
          flexWrap: 'wrap',
          '@media screen and (max-width:750px)': {
            width: '100%',
            margin: 'auto 0',
            textAlign: 'center',
          },
          '& > input, & > textarea, & > select': {
            width: '100%',
            height: '40px',
            padding: '8px',
            fontFamily: theme.typography.fontFamily,
            border: '0.5px solid grey',
            borderRadius: '0.5em',
            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1) inset',
            '&:focus': {
              outline: `1.2px ${theme.palette.primary.main} outset`,
            },
          },
          '& #image': {
            boxShadow: 'none',
            border: 'none',
          },
          '& > input[type="checkbox"]': {
            boxShadow: 'none',
          },
          '& > textarea': {
            height: '10em',
          },
          '& > img': {
            width: '100%',
            objectFit: 'contain',
            maxHeight: '300px',
          },
          '& $helptext': {
            fontSize: '0.8rem',
            color: 'grey',
            textAlign: 'start',
            '& > a': {
              textDecoration: 'underline',
              '&:link': {
                color: theme.palette.primary.main,
              },
            },
            '& > span': {
              color: 'red',
              textDecoration: 'underline',
              fontWeight: 'bold',
            },
          },
        },

        '@media screen and (max-width:750px)': {
          flexWrap: 'wrap',
        },
      },
    },
  },
  arrow: {
    width: '100%',
    margin: '80px auto !important',
    borderRadius: '0.5em',
    backgroundColor: theme.palette.primary.main,
    '& > button': {
      width: '100%',
      padding: '4px 8px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#FFF',
      cursor: 'pointer',
      '& > span': {
        // 上下中央に配置
        display: 'inline-block',
        lineHeight: '32px',
        fontFamily: theme.typography.fontFamily,
        fontSize: '1rem',
      },
      '& > svg': {
        width: '32px',
        height: '32px',
      },
    },
  },
}));

const memberErrorStatus = (error) => {
  const status = diagnosticProperty(diagnosticProperty(error, 'response'), 'status') ?? diagnosticProperty(error, 'status');
  return Number.isInteger(status) && status >= 100 && status <= 599 ? status : null;
};

const memberErrorKind = (error) => {
  const code = diagnosticProperty(error, 'code');
  if (code === 'TOUZEN_MEMBER_INVALID_RESPONSE') return 'invalid-response';
  if (memberErrorStatus(error) !== null) return 'http';
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(code)) return 'timeout';
  if (code === 'ERR_NETWORK' || (diagnosticProperty(error, 'request') && !diagnosticProperty(error, 'response'))) return 'network';
  return 'unknown';
};

const presetFields = ['last_name', 'last_name_kana', 'first_name', 'first_name_kana', 'email',
  'phone_number', 'address1', 'address2', 'address3', 'address4'];
const presetFieldMap = (initial, confirmation = false) => Object.fromEntries(
  (confirmation ? [...presetFields, 'email_confirm'] : presetFields).map((key) => [key, initial]));
const diagnosticProperty = (value, key) => {
  try { return value?.[key]; } catch { return undefined; }
};
const diagnosticUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const diagnosticId = (value) => {
  if (typeof value === 'string' && diagnosticUuid.test(value)) return value;
  if ((typeof value === 'string' && /^[1-9][0-9]{0,15}$/.test(value)) || typeof value === 'number') {
    const number = Number(value);
    if (Number.isSafeInteger(number) && number > 0) return String(number);
  }
  return null;
};
const unknownPresetEnvironment = () => ({
  browser: { family: 'unknown', reported_version: null, verified: false },
  os: { family: 'unknown', reported_version: null, verified: false, version_may_be_frozen: null },
  device: { family: 'unknown', basis: 'unknown' },
});
const presetEnvironment = () => {
  const result = unknownPresetEnvironment();
  try {
    const ua = navigator.userAgent;
    if (typeof ua !== 'string' || ua.length > 1024 || !/^Mozilla\/5\.0\b/.test(ua)) return result;
    if ([/\biPhone\b/, /\biPad\b/, /\bMacintosh\b/, /\bAndroid\b/, /\bWindows NT\b/]
      .filter((pattern) => pattern.test(ua)).length > 1) return result;
    const version = (raw) => {
      const normalized = typeof raw === 'string' ? raw.replace(/_/g, '.') : '';
      return /^[0-9]{1,4}(?:\.[0-9]{1,4}){0,3}$/.test(normalized) ? normalized : null;
    };
    const browsers = [
      ['edge', /(?:EdgiOS|EdgA|Edg)\/([^\s;)]+)/],
      ['chrome', /(?:CriOS|Chrome)\/([^\s;)]+)/],
      ['firefox', /(?:FxiOS|Firefox)\/([^\s;)]+)/],
    ];
    const knownBrowser = browsers.find(([, pattern]) => pattern.test(ua));
    if (knownBrowser) {
      const reported = version(ua.match(knownBrowser[1])?.[1]);
      if (reported) result.browser = { family: knownBrowser[0], reported_version: reported, verified: false };
    } else if (/AppleWebKit\//.test(ua) && /Safari\//.test(ua) && !/(?:OPR|OPiOS|SamsungBrowser|DuckDuckGo|GSA)\//.test(ua)) {
      const reported = version(ua.match(/Version\/([^\s;)]+)/)?.[1]);
      if (reported) result.browser = { family: 'safari', reported_version: reported, verified: false };
    }
    const setOs = (family, reported) => {
      result.os.family = family;
      result.os.reported_version = version(reported);
    };
    if (/\biPad\b/.test(ua)) {
      setOs('ipados', ua.match(/CPU (?:iPhone )?OS ([^\s;)]+)/)?.[1]);
      result.device = { family: 'ipad', basis: 'reported' };
    } else if (/\biPhone\b/.test(ua)) {
      setOs('ios', ua.match(/CPU iPhone OS ([^\s;)]+)/)?.[1]);
      result.device = { family: 'iphone', basis: 'reported' };
    } else if (/\bMacintosh\b/.test(ua)) {
      if (navigator.maxTouchPoints > 1 || /\bMobile\//.test(ua)) {
        result.device = { family: 'ipad-or-mac', basis: 'ambiguous' };
      } else {
        setOs('macos', ua.match(/Mac OS X ([^\s;)]+)/)?.[1]);
        result.device = { family: 'mac', basis: 'reported' };
      }
    } else if (/\bAndroid\b/.test(ua)) {
      setOs('android', ua.match(/Android ([^\s;)]+)/)?.[1]);
      result.device = { family: /\bMobile\b/.test(ua) ? 'android-phone' : 'android-tablet', basis: 'heuristic' };
    } else if (/\bWindows NT\b/.test(ua)) {
      setOs('windows', ua.match(/Windows NT ([^\s;)]+)/)?.[1]);
      result.device = { family: 'windows-pc', basis: 'reported' };
    } else if (/\bLinux\b/.test(ua)) {
      setOs('linux');
      result.device = { family: 'linux-pc', basis: 'reported' };
    }
    // UA reports are unverified; Safari freezes OS versions, including iOS/iPadOS from 26.
    if (result.browser.family === 'safari') {
      const major = Number(result.browser.reported_version.split('.')[0]);
      if (result.os.family === 'macos' || result.device.basis === 'ambiguous' ||
        (['ios', 'ipados'].includes(result.os.family) && major >= 26)) result.os.version_may_be_frozen = true;
    }
    return result;
  } catch { return unknownPresetEnvironment(); }
};

const SeminarApplyForm = () => {
  const {
    register,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {},
  });

  const { user: contextUser, isAuth, authReady } = useContext(AuthContext);
  const user = isAuth === false ? null : contextUser;
  const [member, setMember] = useState();
  const [singleClass, setSingleClass] = useState(false);
  const [detail, setDetail] = useState();
  const [komaNum, setKomaNum] = useState();
  const [unitPrice, setUnitPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const [shownPaymentDialog, setShownPaymentDialog] = useState(false);
  const [shownPaymentDialog2, setShownPaymentDialog2] = useState(false);
  const [shownPaymentDialog3, setShownPaymentDialog3] = useState(false);
  const [preparation, setPreparation] = useState({ status: 'unrequested' });
  const [reload, setReload] = useState(0);
  const [submitError, setSubmitError] = useState('');
  const submission = useRef(null);
  const scope = useRef(null);
  const reportedPreparation = useRef(null);
  const formRef = useRef(null);
  const [pendingPreset, setPendingPreset] = useState(null);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const TIMEZONE = various.timezone;
  const location = useLocation();
  const navigate = useNavigate();

  const uuid = location.state?.uuid;
  const identity = user?.email || (isAuth ? 'unavailable' : 'guest');
  const scopeKey = `${uuid}:${identity}:${authReady === false ? 'loading' : 'ready'}`;
  scope.current = scopeKey;
  const ready = preparation.status === 'success' && preparation.scope === scopeKey && Boolean(komaNum);


  const element = useRef();
  const classes = useStyles();

  // if (detail) console.log('detail', detail);
  // if (product) console.log('product', product);
  // if (member) console.log('member', member);
  // if (isFreeMember) console.log('isFreeMember');
  // if (stripeCustomer) console.log('stripeCustomer', stripeCustomer);
  // if (applyData) console.log('applyData', applyData);
  // console.log('isAlwaysUseCreditCard', isAlwaysUseCreditCard);

  // OGP設定
  const ogp = useCallback((props) => {
    ogpGenerator(props);
  }, []);

  useLayoutEffect(() => {
    if (detail) {
      const ogpProps = {
        page: 'seminar_apply',
        pageTitle:
          detail.title +
          (detail.serial_number ? ` #${detail.serial_number}` : '') +
          'セミナー申し込みページ',
        path: location.pathname,
        imageUrl: detail.image,
      };
      ogp(ogpProps);
    }
  }, [detail, location, ogp]);
  // OGP設定ここまで

  // Resolve the normal payment path first; failures retain public application fallback.
  useEffect(() => {
    let active = true;
    const current = () => active && scope.current === scopeKey;
    const diagnostic = { member_request_state: 'unrequested', http_status: null,
      finite_error_kind: null, prefill_reached: false,
      member: { account_id: diagnosticId(diagnosticProperty(user, 'id')) || diagnosticId(diagnosticProperty(user, 'uuid')),
        member_id: null, identity_match: null,
        field_presence: presetFieldMap(null), field_prefill_completed: presetFieldMap(false, true),
        field_dom_matches: presetFieldMap(null, true) } };
    const expectedValues = {};
    let memberSettled = Promise.resolve();
    const reportPreset = () => {
      if (current()) setPendingPreset({ current, diagnostic, expectedValues, scope: scopeKey, reload });
    };
    const options = { rejectOnError: true, useAuthInterceptor: true };
    submission.current = null;
    setLoading(false);
    setShownPaymentDialog(false);
    setShownPaymentDialog2(false);
    setShownPaymentDialog3(false);
    setSubmitError('');
    setMember(undefined);
    setDetail(undefined);
    setKomaNum(undefined);
    reset({});
    setPreparation({ status: 'loading', scope: scopeKey });
    setPendingPreset(null);
    if (isAuth && authReady === false) return () => { active = false; };

    const load = async () => {
      const memberRequest = user?.email
        ? memberDetailByUserEmail(null, user.email, options).then((value) => {
            diagnostic.member_request_state = 'success';
            if (current()) {
              diagnostic.member.member_id = diagnosticId(diagnosticProperty(value, 'uuid'));
              const returnedEmail = diagnosticProperty(value, 'email');
              const requestedEmail = diagnosticProperty(user, 'email');
              diagnostic.member.identity_match = typeof returnedEmail === 'string' && typeof requestedEmail === 'string'
                ? returnedEmail === requestedEmail : null;
              setMember(value);
              diagnostic.prefill_reached = true;
              const defaults = {};
              presetFields.forEach((key) => {
                defaults[key] = value[key] || '';
                expectedValues[key] = defaults[key];
                diagnostic.member.field_presence[key] = Boolean(defaults[key]);
              });
              // Prefill identity fields without resetting participation chosen in this scope.
              Object.entries(defaults).forEach(([key, fieldValue]) => {
                setValue(key, fieldValue, { shouldValidate: true });
                diagnostic.member.field_prefill_completed[key] = true;
              });
              const confirmationEmail = value.email;
              expectedValues.email_confirm = confirmationEmail;
              setValue('email_confirm', confirmationEmail, { shouldValidate: true });
              diagnostic.member.field_prefill_completed.email_confirm = true;
            }
            return { value, status: 'success' };
          }).catch((error) => {
            diagnostic.http_status = memberErrorStatus(error);
            diagnostic.finite_error_kind = diagnostic.member_request_state === 'success' ? 'prefill' : memberErrorKind(error);
            if (diagnostic.member_request_state !== 'success') diagnostic.member_request_state = 'error';
            if (current()) setMember(null);
            return { value: null, status: 'error' };
          })
        : Promise.resolve({ value: null, status: isAuth ? 'error' : 'absent' });
      memberSettled = memberRequest;
      const paramsRequest = paramsIndexForGeneral(null, options)
        .then((value) => ({ value, status: 'success' }))
        .catch(() => ({ value: [], status: 'error' }));
      const detailRequest = seminarDetailPreview(null, uuid, options).then((value) => {
        if (current()) setDetail(value);
        return value;
      });
      const [profile, parameters, seminar] = await Promise.all([memberRequest, paramsRequest, detailRequest]);
      if (!current()) return;
      setMember(profile.value);
      let selected = null;
      let product = null;
      let productStatus = 'unrequested';
      try {
        selected = await choiceSeminarProduct({ seminar_uuid: uuid, member_uuid: profile.value?.uuid || null }, null, null, options);
        if (!current()) return;
        if (selected.seminar_product_uuid !== null) {
          product = await productMasterDetailOnlyPrice(null, selected.seminar_product_uuid, options);
          productStatus = 'success';
        } else {
          productStatus = 'absent'; // Only the server's explicit null authorizes a waiver.
        }
      } catch (error) {
        const reason = error.response?.data?.error;
        const legacy = new Date(seminar.event_date_start_time).getTime() <= various.stripe.implementationDate.getTime();
        // This endpoint also wraps operational exceptions in HTTP 400.
        const eligibilityRefused = reason === '退会済みのため、セミナー申し込みできません。';
        const currentProductMissing = !legacy && reason === '申し込み可能な商品がありません。';
        if (error.response?.status === 400 && (eligibilityRefused || currentProductMissing)) {
          throw new Error(reason);
        }
        productStatus = 'error';
      }
      if (!current()) return;
      const isFreeMember = Boolean(profile.value && selected?.seminar_product_uuid === null);
      const staff = various.stripe.testRunStaff.includes(profile.value?.email);
      const showPayment = Boolean(profile.value && parameters.value.find((param) => param.title === 'run_stripe_in_production')?.apply_is &&
        (parameters.value.find((param) => param.title === 'run_stripe_all_members')?.apply_is || staff));
      const usePayment = showPayment && !seminar.payment_method?.is_only_cash && !isFreeMember && productStatus === 'success';
      let customer = null;
      let customerStatus = 'unrequested';
      if (usePayment) {
        try {
          customer = await getStripeCustomerInfo(null, profile.value.email, options);
          customerStatus = customer === null ? 'absent' : 'success';
        } catch (error) {
          customerStatus = 'error';
        }
      }
      if (!current()) return;
      setPreparation({ status: 'success', scope: scopeKey, memberStatus: profile.status,
        paramsStatus: parameters.status, productStatus, customerStatus,
        context: { member: profile.value, detail: seminar, product, selected, isFreeMember, customer,
          usePayment: usePayment && customerStatus !== 'error' },
        fallback: [profile.status, parameters.status, productStatus, customerStatus].includes('error') });
    };
    if (uuid) load().catch((error) => {
      if (current()) setPreparation({ status: 'error', scope: scopeKey, message: error.message || 'セミナー情報を取得できませんでした。' });
    }).finally(async () => {
      await memberSettled;
      reportPreset();
    });
    else {
      setPreparation({ status: 'error', scope: scopeKey, message: '対象のセミナーを確認できませんでした。' });
      reportPreset();
    }
    return () => { active = false; };
  }, [scopeKey, uuid, user?.email, isAuth, authReady, reset, setValue, reload]);

  // Sample only after React has committed the settled form; raw values stay in this browser.
  useEffect(() => {
    if (!pendingPreset?.current() || pendingPreset.scope !== scopeKey || pendingPreset.reload !== reload ||
      (reportedPreparation.current?.scope === scopeKey && reportedPreparation.current?.reload === reload)) return;
    if (preparation.status === 'success' && !komaNum) return;
    reportedPreparation.current = { scope: scopeKey, reload };
    try {
      const { diagnostic, expectedValues } = pendingPreset;
      if (formRef.current) {
        Object.keys(diagnostic.member.field_dom_matches).forEach((key) => {
          if (!Object.prototype.hasOwnProperty.call(expectedValues, key)) return;
          try {
            const input = formRef.current.elements.namedItem(key);
            if (input && typeof input.value === 'string') diagnostic.member.field_dom_matches[key] = input.value === String(expectedValues[key] ?? '');
          } catch { /* An unavailable field remains unknown. */ }
        });
      }
      const payload = {
        client_reported_at: new Date().toISOString(), // Client clock; not a server-verified timestamp.
        logged_in: Boolean(isAuth), auth_ready: authReady !== false, identity_present: Boolean(user?.email),
        member_request_state: diagnostic.member_request_state, http_status: diagnostic.http_status,
        finite_error_kind: diagnostic.finite_error_kind, prefill_reached: diagnostic.prefill_reached,
        environment: presetEnvironment(), member: diagnostic.member,
      };
      try { console.info('[seminar-preset]', payload); } catch { /* Best-effort console output. */ }
      const incomplete = Object.keys(payload.member.field_prefill_completed).some((key) =>
        payload.member.field_presence[key === 'email_confirm' ? 'email' : key] === true && !payload.member.field_prefill_completed[key]);
      const missingRequired = payload.member_request_state === 'success' && presetFields.some((key) =>
        key !== 'address4' && payload.member.field_presence[key] === false);
      const abnormal = !payload.identity_present || payload.member_request_state === 'error' || payload.member.identity_match === false ||
        payload.finite_error_kind === 'prefill' || incomplete || missingRequired || Object.values(payload.member.field_dom_matches).includes(false);
      if (payload.logged_in && payload.auth_ready && typeof uuid === 'string' && diagnosticUuid.test(uuid) && abnormal) {
        Promise.resolve(reportSeminarPresetDiagnostic(payload)).catch(() => {});
      }
    } catch { /* Diagnostics must not interrupt an application. */ }
  }, [pendingPreset, scopeKey, reload, preparation.status, komaNum, isAuth, authReady, user?.email, uuid]);

  useEffect(() => {
    if (detail) {
      setSingleClass(new Date(detail.part_two_start_time).getHours() === 23 &&
        new Date(detail.part_two_start_time).getMinutes() === 59);
      let komanum = 1;
      const seminarTime = {
        part2: Clock({
          timezone: TIMEZONE,
          time: null,
          string: detail.part_two_end_time,
        }).hour,
        part3: detail.part_three_end_time
          ? Clock({
              timezone: TIMEZONE,
              time: null,
              string: detail.part_three_end_time,
            }).hour
          : null,
        part4: detail.part_four_end_time
          ? Clock({
              timezone: TIMEZONE,
              time: null,
              string: detail.part_four_end_time,
            }).hour
          : null,
      };
      if (seminarTime.part2 !== 23) komanum += 1;
      if (seminarTime.part3 !== null) komanum += 1;
      // 現状、4コマ目は肝稽古用として使用しているため、コマ数にはカウントせず
      // if (seminarTime.part4 !== null) komanum += 1;
      setKomaNum(komanum);
    }
  }, [detail, TIMEZONE]);

  useEffect(() => {
    if (komaNum && detail) {
      const oneDayPrice = detail.membership_fee;
      setUnitPrice(oneDayPrice ? oneDayPrice / komaNum : 0);
    }
  }, [komaNum, detail]);

  function applicationData(data, current) {
    const { detail: seminarDetail, member, product, isFreeMember } = current;
    // Base info
    const seminar = seminarDetail;
    data['id'] = seminar.uuid;
    data['title'] =
      seminar.title +
      (seminar.serial_number ? ' #' + seminar.serial_number : '');
    data['date'] =
      Clock({
        timezone: TIMEZONE,
        time: null,
        string: seminar.event_date_start_time,
      }).today +
      ' ' +
      Clock({
        timezone: TIMEZONE,
        time: null,
        string: seminar.event_date_start_time,
      }).hourMinutes +
      ' ~';
    data['place'] = seminar.place.facility_name + ' ' + seminar.hall.name;
    data['address'] = seminar.place.address;
    data['gmap'] = seminar.place.gmap;

    // Pricing
    // 申し込みコマ数（最大３コマしか対応していない：４コマ目は肝稽古用として使用しているため）
    let entryKomaCount;
    if (data.radio === '全コマに参加する') {
      entryKomaCount = komaNum;
    } else if (
      data.radio === '第1部に参加する' ||
      data.radio === '第2部に参加する' ||
      data.radio === '第3部に参加する'
    ) {
      entryKomaCount = 1;
    } else {
      entryKomaCount = 2;
    }


    // 単価の把握
    let unitPrice;
    if (product) {
      unitPrice = product.price;
    } else {
      // 商品取得が利用できない場合も、既存のセミナー参加費で公開申込を継続する。
      if (member) {
        unitPrice = seminar.membership_fee / komaNum;
        if (data.is_screening) {
          // 常連組のスクリーニングを行っている。1/3というのは、2023年５月開催の「凝縮稽古」のみなのかもしれない。場当たり的な対応。
          unitPrice = seminar.membership_fee / 3;
        }
      } else {
        unitPrice = seminar.entry_fee / komaNum;
      }
    }
    data.fee = unitPrice * entryKomaCount;

    // Domain info
    data['detaildataPath'] = `/seminar/preview/${seminar.uuid}`;
    data['attention'] = seminar.notes;
    const protocol = window.location.protocol;
    const host = window.location.host;
    const domain = document.domain;
    const path = 'contact';
    const dataset = {
      email: data.email,
      protocol: protocol,
      host: host,
      path: path,
      domain: domain,
    };
    data['urlData'] = dataset;

    // console.log(data);

    if (isFreeMember) data.fee = 0;
    if (member) data.member_uuid = member.uuid;
    return { data, units: entryKomaCount };
  }

  const isCurrentSubmission = (attempt) => submission.current === attempt && scope.current === attempt.scope;
  const releaseSubmission = (attempt, message = '') => {
    if (!isCurrentSubmission(attempt)) return;
    submission.current = null;
    setLoading(false);
    setSubmitError(message);
  };
  async function completeApplication(attempt) {
    if (!isCurrentSubmission(attempt) || attempt.phase === 'applying' || attempt.phase === 'complete') return;
    attempt.phase = 'applying';
    try {
      await seminarApply(null, null, attempt.data, { rejectOnError: true });
      if (!isCurrentSubmission(attempt)) return;
      attempt.phase = 'complete';
      alert(attempt.context.member && attempt.context.detail.payment_method?.is_only_cash
        ? 'お申し込みいただき、ありがとうございます。本セミナーは『現金払いのみ』のセミナーです。ご注意ください。'
        : 'お申し込みいただき、ありがとうございます。受付メールを送信いたしました。ご確認ください。');
      navigate(various.general.seminar);
    } catch (error) {
      releaseSubmission(attempt, 'お申し込みを完了できませんでした。もう一度お試しください。');
    }
  }
  function paymentNavigation(attempt, initial = false) {
    if (!isCurrentSubmission(attempt) || attempt.phase === 'complete') return;
    attempt.phase = 'complete';
    const current = attempt.context;
    const data = { ...attempt.data, apply_unit: attempt.units, product_uuid: current.selected.seminar_product_uuid };
    if (initial) Object.assign(data, { customer_id: null, customer_email: null, user_email: current.member.email, redirect: true });
    navigate(initial ? various.general.paymentView : various.general.paymentViewOfOthers, {
      state: { previous: location.pathname, customer_id: initial ? null : current.customer?.stripe_customer_id,
        customer_email: initial ? null : current.customer?.email, user_email: current.member.email,
        apply_data: data, ...(initial ? { isInitial: true } : {}) },
    });
  }
  const onSubmit = async (values) => {
    if (!ready || submission.current) return;
    if (!executeRecaptcha) { setSubmitError('送信の準備ができていません。もう一度お試しください。'); return; }
    const attempt = { scope: scopeKey, context: preparation.context, phase: 'checking' };
    submission.current = attempt;
    setLoading(true);
    setSubmitError('');
    try {
      const token = await executeRecaptcha('contact');
      if (!isCurrentSubmission(attempt)) return;
      if (!token) throw new Error('recaptcha unavailable');
      const seminarDate = new Date(Date.parse(attempt.context.detail.event_date_start_time.replace(/-/g, '/')));
      if (new Date().getTime() > seminarDate.getTime()) {
        alert('本セミナーはすでに終了しました。');
        attempt.phase = 'complete';
        navigate(various.general.seminar);
        return;
      }
      Object.assign(attempt, applicationData({ ...values, g_recaptcha_response: token }, attempt.context));
      let usePayment = attempt.context.usePayment;
      if (attempt.context.member && !attempt.context.isFreeMember) {
        let status;
        try { status = await checkSeminarStatus(null, null, attempt.data, { rejectOnError: true }); }
        catch (error) { usePayment = false; }
        if (!isCurrentSubmission(attempt)) return;
        if (status?.status === 'failed') {
          const message = status.message || 'お申し込みできません。';
          window.alert(message);
          releaseSubmission(attempt, message);
          return;
        }
      }
      if (!usePayment) { await completeApplication(attempt); return; }
      const { customer, member } = attempt.context;
      attempt.phase = 'dialog';
      if (customer?.by_stripe && customer.credit_cards?.length > 0) {
        if (customer.always_use_a_credit_card) paymentNavigation(attempt);
        else setShownPaymentDialog3(true);
      } else if (customer) {
        if (customer.is_show_dialog) setShownPaymentDialog2(true);
        else await completeApplication(attempt);
      } else if (member.is_show_dialog) setShownPaymentDialog(true);
      else await completeApplication(attempt);
    } catch (error) {
      releaseSubmission(attempt, 'お申し込みを送信できませんでした。もう一度お試しください。');
    }
  };

  const isOnline = watch('online');
  useEffect(() => { if (isOnline) setValue('radio', '全コマに参加する'); }, [isOnline, setValue]);
  const closeDialog = () => {
    setShownPaymentDialog(false); setShownPaymentDialog2(false); setShownPaymentDialog3(false);
    const attempt = submission.current;
    if (attempt?.phase === 'dialog') releaseSubmission(attempt);
  };
  const handleClose = closeDialog;
  const handleClose2 = closeDialog;
  const handleClose3 = closeDialog;
  const gotoPaymentView = () => { if (submission.current?.phase === 'dialog') paymentNavigation(submission.current, true); };
  const gotoPaymentView2 = () => { if (submission.current?.phase === 'dialog') paymentNavigation(submission.current); };
  const disagreePayment = () => {
    const attempt = submission.current;
    if (attempt?.phase !== 'dialog') return;
    setShownPaymentDialog(false); setShownPaymentDialog2(false); setShownPaymentDialog3(false);
    completeApplication(attempt);
  };
  const disagreePayment2 = disagreePayment;
  const disagreePayment3 = disagreePayment;
  const updateDoNotShowAgain = () => setDoNotShowAgain();

  const form = () => {
    return (
      <div className={classes.formContainer}>
        <form ref={formRef} encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div className={classes.titles}>
              <label htmlFor="お名前（姓）">{'お名前（姓）'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="last_name"
                type="text"
                disabled={member ? true : false}
                {...register('last_name', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.last_name?.message && (
                <div className={classes.error}>{errors.last_name.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="お名前（カナ姓）">{'お名前（カナ姓）'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="last_name_kana"
                type="text"
                disabled={member ? true : false}
                {...register('last_name_kana', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.last_name_kana?.message && (
                <div className={classes.error}>
                  {errors.last_name_kana.message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="お名前（名）">{'お名前（名）'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="first_name"
                type="text"
                disabled={member ? true : false}
                {...register('first_name', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.first_name?.message && (
                <div className={classes.error}>{errors.first_name.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="お名前（カナ名）">{'お名前（カナ名）'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="first_name_kana"
                type="text"
                disabled={member ? true : false}
                {...register('first_name_kana', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.first_name_kana?.message && (
                <div className={classes.error}>
                  {errors.first_name_kana.message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="Eメール">{'Eメール'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="email"
                type="email"
                disabled={member ? true : false}
                {...register('email', {
                  required: { value: true, message: '入力必須の項目です' },
                  validate: {
                    message: (v) =>
                      emailRegValidator(v)
                        ? null
                        : `※正しいEメールの形式で入力してください`,
                  },
                })}
              />
              {errors.email?.message && (
                <div className={classes.error}>{errors.email.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="Eメール（確認）">{'Eメール（確認）'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="email_confirm"
                type="email"
                disabled={member ? true : false}
                {...register('email_confirm', {
                  required: { value: true, message: '入力必須の項目です' },
                  validate: {
                    message: (v) =>
                      emailValidator(v)
                        ? null
                        : `上と同一のものを入力してください。`,
                  },
                })}
              />
              {errors.email_confirm?.message && (
                <div className={classes.error}>
                  {errors.email_confirm.message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="電話番号">{'電話番号'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="phone_number"
                type="text"
                disabled={member ? true : false}
                {...register('phone_number', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.phone_number?.message && (
                <div className={classes.error}>
                  {errors.phone_number.message}
                </div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="都道府県">{'都道府県'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="address1"
                type="text"
                disabled={member ? true : false}
                {...register('address1', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.address1?.message && (
                <div className={classes.error}>{errors.address1.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="市区町村">{'市区町村'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="address2"
                type="text"
                disabled={member ? true : false}
                {...register('address2', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.address2?.message && (
                <div className={classes.error}>{errors.address2.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="番地">{'番地'}</label>
              <span> *</span>
            </div>
            <div className={classes.inputs}>
              <input
                id="address3"
                type="text"
                disabled={member ? true : false}
                {...register('address3', {
                  required: { value: true, message: '入力必須の項目です' },
                })}
              />
              {errors.address3?.message && (
                <div className={classes.error}>{errors.address3.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="建物名等">{'建物名等'}</label>
            </div>
            <div className={classes.inputs}>
              <input
                id="address4"
                type="text"
                disabled={member ? true : false}
                {...register('address4', {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              {errors.address4?.message && (
                <div className={classes.error}>{errors.address4.message}</div>
              )}
            </div>
          </div>
          <div>
            <div className={classes.titles}>
              <label htmlFor="参加希望のコマ">{'参加希望のコマ'}</label>
              <span> *</span>
            </div>
            <div
              className={classes.inputs}
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div>
                {new Date(detail.part_two_start_time).getHours() === 23 &&
                new Date(detail.part_two_start_time).getMinutes() === 59 ? (
                  <>
                    <input
                      id="koma1"
                      type="radio"
                      name="koma_section"
                      value="全コマに参加する"
                      disabled={singleClass}
                      {...register('radio')}
                    />
                    <label htmlFor="koma1">全コマに参加する</label>
                  </>
                ) : (
                  <>
                    <input
                      id="koma1"
                      type="radio"
                      name="koma_section"
                      value="全コマに参加する"
                      defaultChecked
                      {...register('radio')}
                    />
                    <label htmlFor="koma1">全コマに参加する</label>
                  </>
                )}
              </div>
              <div>
                {new Date(detail.part_two_start_time).getHours() === 23 &&
                new Date(detail.part_two_start_time).getMinutes() === 59 ? (
                  <>
                    <input
                      id="koma2"
                      type="radio"
                      name="koma_section"
                      value="第1部に参加する"
                      defaultChecked
                      disabled={isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma2">第1部に参加する</label>
                  </>
                ) : (
                  <>
                    <input
                      id="koma2"
                      type="radio"
                      name="koma_section"
                      value="第1部に参加する"
                      disabled={isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma2">第1部に参加する</label>
                  </>
                )}
              </div>
              <div>
                <input
                  id="koma3"
                  type="radio"
                  name="koma_section"
                  value="第2部に参加する"
                  disabled={singleClass || isOnline}
                  {...register('radio')}
                />
                <label htmlFor="koma3">第2部に参加する</label>
              </div>
              {detail.part_three_start_time ? (
                <>
                  <div>
                    <input
                      id="koma4"
                      type="radio"
                      name="koma_section"
                      value="第3部に参加する"
                      disabled={singleClass || isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma4">第3部に参加する</label>
                  </div>
                  <div>
                    <input
                      id="koma5"
                      type="radio"
                      name="koma_section"
                      value="第1部&第2部に参加する"
                      disabled={singleClass || isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma5">第1部&第2部に参加する</label>
                  </div>
                  <div>
                    <input
                      id="koma6"
                      type="radio"
                      name="koma_section"
                      value="第2部&第3部に参加する"
                      disabled={singleClass || isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma6">第2部&第3部に参加する</label>
                  </div>
                  <div>
                    <input
                      id="koma7"
                      type="radio"
                      name="koma_section"
                      value="第1部&第3部に参加する"
                      disabled={singleClass || isOnline}
                      {...register('radio')}
                    />
                    <label htmlFor="koma7">第1部&第3部に参加する</label>
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
          </div>
          <br />
          {detail.part_four_start_time ? (
            <div>
              <div className={classes.titles}>
                <label htmlFor="懇親会への参加">{'懇親会への参加'}</label>
              </div>
              <div className={classes.inputs}>
                <input
                  id="kangeiko"
                  type="checkbox"
                  {...register('kangeiko', {
                    required: { value: false, message: '入力必須の項目です' },
                  })}
                />
                <div className={classes.helptext}>
                  懇親会への参加を希望される方はチェックを入れてください。
                </div>
                {errors.kangeiko?.message && (
                  <div className={classes.error}>{errors.kangeiko.message}</div>
                )}
              </div>
            </div>
          ) : (
            ''
          )}
          <br />
          {detail.is_screening ? (
            <>
              <div>
                <div className={classes.titles}>
                  <label htmlFor="講習会”常連”実績の有無">
                    {'講習会”常連”実績の有無'}
                  </label>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="is_screening"
                    type="checkbox"
                    {...register('is_screening', {
                      required: { value: false, message: '入力必須の項目です' },
                    })}
                  />
                  <div className={classes.helptext}>
                    これまで小用先生のご開催された数々の講習会において、『20回以上』の参加実績がある方はチェックを入れてください。
                    <br />
                    ※自己申告で構いません。お問合せをいただいても、現在運営では当該データがありませんので回答はできかねます。
                  </div>
                  {errors.is_screening?.message && (
                    <div className={classes.error}>
                      {errors.is_screening.message}
                    </div>
                  )}
                </div>
              </div>
              <br />
            </>
          ) : (
            ''
          )}
          {detail.is_secret ? (
            <>
              <div>
                <div className={classes.titles}>
                  <label htmlFor="秘伝講習への同意">{'秘伝講習への同意'}</label>
                </div>
                <div className={classes.inputs}>
                  <input
                    id="is_secret"
                    type="checkbox"
                    {...register('is_secret', {
                      required: { value: true, message: '入力必須の項目です' },
                    })}
                    checked={true}
                  />
                  <div className={classes.helptext}>
                    セミナーの内容に関して、刀禅老師が直接伝達する場面でのみ練行し、会員同士を含め、当該セミナーに参加していない人にセミナーの内容を伝えないことにご同意ください。なお、独り稽古は大いに励んで下さい。
                    <br />
                    ※ご同意いただけない場合は、お申し込みはできません。
                  </div>
                  {errors.is_secret?.message && (
                    <div className={classes.error}>
                      {errors.is_secret.message}
                    </div>
                  )}
                </div>
              </div>
              <br />
            </>
          ) : (
            ''
          )}
          {detail.is_online && (
            <div>
              <div className={classes.titles}>
                <label htmlFor="OnLine参加">{'OnLine参加'}</label>
              </div>
              <div className={classes.inputs}>
                <input
                  id="online"
                  type="checkbox"
                  {...register('online', {
                    required: { value: false, message: '入力必須の項目です' },
                  })}
                />
                <div className={classes.helptext}>
                  オンラインでの参加を希望される方はチェックを入れてください。なお、オンライン参加の場合は
                  <span className={classes.onlyAll}>"全コマへの参加のみ"</span>
                  となります。ご注意ください。
                </div>
                {errors.online?.message && (
                  <div className={classes.error}>{errors.online.message}</div>
                )}
              </div>
            </div>
          )}
          <div>
            <div className={classes.titles}>
              <label htmlFor="自由記入欄">{'自由記入欄'}</label>
            </div>
            <div className={classes.inputs}>
              <textarea
                id="free_wright"
                type="text"
                {...register('free_wright', {
                  required: { value: false, message: '入力必須の項目です' },
                })}
              />
              {errors.free_wright?.message && (
                <div className={classes.error}>
                  {errors.free_wright.message}
                </div>
              )}
            </div>
          </div>
          <div className={classes.arrow}>
            <button type="submit" disabled={!ready || loading}>
              <span>SUBMIT</span>
              <imageIndex.arrowIcon />
            </button>
          </div>
        </form>
      </div>
    );
  };

  const formMapping = () => {
    if (detail && komaNum) {
      // console.log('detail', detail);
      return (
        <>
          <div className={classes.contentTitle}>
            <ContentTitle
              title={{ titleList: ['セミナー参加申し込み'], sub: null }}
            />
          </div>
          <div className={classes.applyContents}>
            <div ref={element} id="target_apply_0" className={classes.image}>
              <img src={detail.image} alt="seminarImage" />
            </div>
            <div id="read">
              <div id="title">
                <div>対象セミナー :</div>
                <span>
                  {detail.serial_number
                    ? detail.title + ' #' + detail.serial_number
                    : detail.title}
                </span>
              </div>
              <div>
                <div>対象者:</div>
                <span>{detail.subject}</span>
              </div>
              <div>
                <div>定員:</div>
                <span>{detail.capacity}名&nbsp;/&nbsp;部</span>
              </div>
              <div>
                <div>参加費:</div>
                <div id="price">
                  {!unitPrice ? (
                    <span>{unitPrice.toLocaleString()}円</span>
                  ) : komaNum === 1 ? (
                    <span>1,000円〜{unitPrice.toLocaleString()}円 / 通し</span>
                  ) : (
                    <span>1,000円〜{unitPrice.toLocaleString()}円 / 1コマ</span>
                  )}
                  {detail.payment_method?.is_only_cash ? (
                    <span id="cashOnly">※現金払いのみ</span>
                  ) : null}
                </div>
                {/* {detail.subject === '会員' ? (
                  detail.membership_fee ? (
                    <span>
                      会員&nbsp;:&nbsp;
                      {detail.membership_fee.toLocaleString()}
                      円&nbsp;/&nbsp;日
                    </span>
                  ) : (
                    <span>会員&nbsp;:&nbsp;無料</span>
                  )
                ) : (
                  <>
                    <span>
                      会員&nbsp;:&nbsp;
                      {detail.membership_fee.toLocaleString()}
                      円&nbsp;/&nbsp;日
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span>
                      一般&nbsp;:&nbsp;
                      {detail.entry_fee.toLocaleString()}
                      円&nbsp;/&nbsp;日
                    </span>
                  </>
                )} */}
              </div>
              <div>
                <div>開催日:</div>
                <span>
                  {
                    Clock({
                      timezone: TIMEZONE,
                      time: null,
                      string: detail.event_date_start_time,
                    }).today
                  }
                  &nbsp;
                  {
                    Clock({
                      timezone: TIMEZONE,
                      time: null,
                      string: detail.part_one_start_time,
                    }).hourMinutes
                  }
                  &nbsp;~
                </span>
              </div>
              {singleClass ? (
                <>
                  {/* 1コマのみの場合 */}
                  <div>
                    <div>第一部:</div>
                    <span>
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_one_start_time,
                        }).hourMinutes
                      }
                      &nbsp;-&nbsp;
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_one_end_time,
                        }).hourMinutes
                      }
                    </span>
                  </div>
                </>
              ) : (
                <>
                  {/* 2コマ以上の場合 */}
                  <div>
                    <div>第一部:</div>
                    <span>
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_one_start_time,
                        }).hourMinutes
                      }
                      &nbsp;-&nbsp;
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_one_end_time,
                        }).hourMinutes
                      }
                    </span>
                  </div>
                  <div>
                    <div>第二部:</div>
                    <span>
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_two_start_time,
                        }).hourMinutes
                      }
                      &nbsp;-&nbsp;
                      {
                        Clock({
                          timezone: TIMEZONE,
                          time: null,
                          string: detail.part_two_end_time,
                        }).hourMinutes
                      }
                    </span>
                  </div>
                </>
              )}
              {detail.part_three_start_time ? (
                <div>
                  <div>第三部:</div>
                  <span>
                    {
                      Clock({
                        timezone: TIMEZONE,
                        time: null,
                        string: detail.part_three_start_time,
                      }).hourMinutes
                    }
                    &nbsp;-&nbsp;
                    {
                      Clock({
                        timezone: TIMEZONE,
                        time: null,
                        string: detail.part_three_end_time,
                      }).hourMinutes
                    }
                  </span>
                </div>
              ) : null}
              {detail.part_four_start_time ? (
                <div>
                  <div>懇親会:</div>
                  <span>
                    {
                      Clock({
                        timezone: TIMEZONE,
                        time: null,
                        string: detail.part_four_start_time,
                      }).hourMinutes
                    }
                    &nbsp;-&nbsp;
                    {
                      Clock({
                        timezone: TIMEZONE,
                        time: null,
                        string: detail.part_four_end_time,
                      }).hourMinutes
                    }
                  </span>
                </div>
              ) : null}
              <div>
                <div>場所:</div>
                <div id="place">
                  <span>
                    {detail.display_name_of_the_place}
                    {detail.is_online && ' / OnLine配信'}
                  </span>
                  <span id="note">
                    ※詳細はお申し込みされた方のみにお知らせいたします。
                  </span>
                </div>
              </div>
            </div>
          </div>
          {loading ? <Spinner /> : form()}
          <StandardDialog
            open={shownPaymentDialog}
            handleClose={handleClose}
            text={{
              title: 'お申し込みありがとうございます。',
              content:
                '決済情報が未登録です。寡少な運営のため、決済情報の登録を"切に"お願いしております。決済情報の登録は、マイページまたは以下のボタンから行うことができます。',
              agree: '決済情報を登録する',
              disagree: '今はしない',
            }}
            func={{
              agreeFunc: gotoPaymentView,
              disagreeFunc: disagreePayment,
              updateDoNotShowAgain: updateDoNotShowAgain,
            }}
          />
          <StandardDialog
            open={shownPaymentDialog2}
            handleClose={handleClose2}
            text={{
              title: 'お申し込みありがとうございます。',
              content:
                '自動決済がキャンセルされています。寡少な運営のため、決済情報の登録を"切に"お願いしております。再度自動決済に戻す場合は以下のボタンから行うことができます。',
              agree: '自動決済に戻す',
              disagree: '今はしない',
            }}
            func={{
              agreeFunc: gotoPaymentView2,
              disagreeFunc: disagreePayment2,
              updateDoNotShowAgain: updateDoNotShowAgain,
            }}
          />
          <StandardDialog
            open={shownPaymentDialog3}
            handleClose={handleClose3}
            text={{
              title: 'お申し込みありがとうございます。',
              content: '本セミナーのお支払い方法をご選択ください。',
              agree: 'クレジットカード',
              disagree: '現金',
            }}
            func={{
              agreeFunc: gotoPaymentView2,
              disagreeFunc: disagreePayment3,
            }}
          />
          <Footer />
        </>
      );
    }
  };

  return (
    <>
      <div>
        <OnOffByScroll place="General" />
      </div>
      {preparation.status === 'loading' && <p role="status">お申し込み情報を確認しています。</p>}
      {preparation.status === 'error' && <div role="alert">{preparation.message}<button type="button" onClick={() => setReload((value) => value + 1)}>再読み込み</button></div>}
      {preparation.fallback && <p role="status">会員・決済情報の一部を確認できませんでした。必要事項を入力してお申し込みいただけます。</p>}
      {submitError && <p role="alert">{submitError}</p>}
      {formMapping()}
    </>
  );
};
export default SeminarApplyForm;
